module.exports = __webpack_public_path__ + "img/i_icon_zell.2b99b3b.png";